<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <title>Remote Monitoring System</title>
  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <!-- <link href="assets/img/favicon.png" rel="icon">-->
  <link href="assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link
    href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Raleway:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
    rel="stylesheet">
  <link href="http://fonts.cdnfonts.com/css/mulish" rel="stylesheet">

</head>

<body>

  <app-header></app-header>





  <section id="hero" class="hero_slide">
    <div data-bs-interval="5000" class="" data-bs-ride="carousel">

      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 mt-3 cust-slider-left-text pad_top_30">
            <h2 class="animate__animated animate__fadeInDown text-alignment-center">Flow Monitoring <br
                class="text_hide"> System</h2>
            <p class="animate__animated animate__fadeInUp width-100 m-0 text-alignment-center">Gets insights of up to
              100 parameters including flow- <br class="text_hide">
              rate, Totalize, Valve working hours at your<br class="text_hide">
              fingertips. Two-way communication can help<br class="text_hide">
              turn on-off flow Values remotely.</p>
            <div class="flex_center pad-top-25">
              <a href="https://www.samyak.com/contact-us/"
                class="btn-get-started animate__animated animate__fadeInUp scrollto margin-top-25 cursor_pointer">Contact
                Us</a>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 text-right">
            <img src="assets/img/Services.svg" class="slider-img-level slider-img">
          </div>
        </div>


      </div>
    </div>
  </section>

  <main id="main">
    <section id="clients" class="clients">
      <div class="container p-0">
        <div class="row client-logo-main">
          <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
            <img src="../../assets/img/Adani-power-logo.svg" class="img-fluid" alt="">
          </div>

          <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
            <img src="../../assets/img/Cognitive Technologies.svg" class="img-fluid" alt="">
          </div>

          <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
            <img src="../../assets/img/Anodyne Technologies.svg" class="img-fluid" alt="">
          </div>

          <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
            <img src="../../assets/img/Energy Doctor (Tricolite Energy Soln).svg" class="img-fluid" alt="">
          </div>

          <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
            <img src="../../assets/img/Navi mumbai corporation.svg" class="img-fluid" alt="">
          </div>

          <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
            <img src="../../assets/img/rech.svg" class="img-fluid" alt="">
          </div>

        </div>

      </div>
    </section>


    <section id="services" class="services">
      <div class="container aos-init aos-animate" data-aos="fade-up">

        <div class="section-title">

          <p class="pt-4 pb-4">What Are The Challenges Do Manufacturer Face?</p>

        </div>

        <div class="align-items-center text-center justify-content-center">
          <img src="assets/img/Flowbanner.gif" alt="">
        </div>

      </div>
    </section>




    <section id="cta" class="cta space-comman">

      <div class="container aos-init aos-animate" data-aos="zoom-in">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <img src="assets/img/iot-chart.svg">
          </div>
          <div class="col-lg-6 col-md-6">
            <div class="">
              <h3 class="pt-4 text-left">What are Flow Monitoring Solutions?</h3>
              <p class="mt-30 text_jus">With Flow Monitoring solutions, you can remotely monitor and analyze daily,
                monthly, weekly or yearly reports of fluid
                consumption through meter reading. It will help in automating meter readings and generating bills.


              </p>
              <p class="mt-30 text_jus">
                Samyak's IIoT device gets connected to field sensors like temp, humidiy, and pressure. Device gets
                connected to flow-meter as well. From there it takes data and send it to cloud. This will allow you to
                access the sensor information on mobile phones as well as desktops. </p>

            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="Advanced Energy" class="services">
      <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row display_two_column-1">
          <div class="second_column_text">
            <div class="second_column_image">
              <div class="section-title Energy-Analytics-title">

                <p class="heading-left">Brief overview of the system</p>

              </div>
              <ul class="overview list_item">
                <li>We offer end to end IIoT solution which comes with
                  everything from Electronics to web and mobile application.</li>
                <li>From your industrial plant,bulidings and machinery,we send required data to cloud server using 4g
                  gsm modem or through wired cabel.</li>
                <li>Server can be any cloud or in-house.</li>
                <li>Once data is on the server, we do reporting, and data analysis as per need.</li>
                <li>It support 2-way communication. So, sitting at remote your tanks can
                  be controlled.</li>
                <li>Custom Alrams,alert messages can be set.</li>
                <li>User defined custom reporting and custom dashboard can be created.</li>
              </ul>
            </div>
          </div>
          <div class="first_column_image pb-3">
            <div class="align-items-center text-center justify-content-center pad_27">

              <img class="embed-responsive-item exporte-img" src="assets/img/flow_monitoring_brief.svg">

            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="How-Rms-Works" class="services gray-container space-comman padding-bottom-50 margin-bottom-0">
      <div class="container aos-init aos-animate" data-aos="fade-up">

        <div class="section-title">

          <p class="pt-4">Flow Monitoring Solutions Application Area</p>

        </div>

        <div class="row pad_15">

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init">
            <div class="icon-box height-435">
              <div class="icon-container"><img src="assets/img/water.svg" class="icon_img_mobile"></div>
              <h4><a href="">Automated Liquid Metering</a></h4>
              <p class="text_jus" style="margin-bottom: 0px !important;">We can connect Samyak's 4g GSM device with
                water meters' and it will send meter readings to cloud. On cloud RMS can help in analyzing meter reading
                and automating bill generation.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
            <div class="icon-box height-435">
              <div class="icon-container"><img src="assets/img/Analysis.svg" class="icon_img_mobile"></div>
              <h4><a href="">Liquid Demand Supply Analysis</a></h4>
              <p class="text_jus" style="margin-bottom: 0px !important;">Get daily, weekly, monthly and yearly insights
                of water consumption on fingertips with the help of end-to-end service of RMS. We can analyze water
                consumption over the years and using data analytics can predict future demand. </p>
            </div>
          </div>


          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
            <div class="icon-box height-435">
              <div class="icon-container"><img src="assets/img/plants.svg" class="icon_img_mobile"></div>
              <h4><a href="">Waste Liquid Treatment Plants</a></h4>
              <p class="text_jus" style="margin-bottom: 0px !important;">Monitor and track water flowing through
                treatment plants. Also RMS can help in capturing pH, BOD, oxygen and many other sensors' data on cloud.
                Based on sensor values and amount of water flowed through pumps, takes decisions when to stop and start
                water treatment seating remotely. </p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init">
            <div class="icon-box height-435">
              <div class="icon-container"><img src="assets/img/ground-water.svg" class="icon_img_mobile"></div>
              <h4><a href="">Ground Water Monitoring</a></h4>
              <p class="text_jus" style="margin-bottom: 0px !important;">We can connect Samyak's 4g GSM device with
                water meters' and it will send meter readings to cloud. On cloud RMS can help in analyzing meter reading
                and automating bill generation.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
            <div class="icon-box height-435">
              <div class="icon-container"><img src="assets/img/dam.svg" class="icon_img_mobile"></div>
              <h4><a href="">Dam Flow and Level Monitoring
                </a></h4>
              <p class="text_jus" style="margin-bottom: 0px !important;">We can connect Samyak's 4g GSM device with
                water meters' and it will send meter readings to cloud. On cloud RMS can help in analyzing meter reading
                and automating bill generation.</p>
            </div>
          </div>


          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
            <div class="icon-box height-435">
              <div class="icon-container"><img src="assets/img/liquid-flow.svg" class="icon_img_mobile"></div>
              <h4><a href="">Liquid Flow Monitoring </a></h4>
              <p class="text_jus" style="margin-bottom: 0px !important;">We can connect Samyak's 4g GSM device with
                water meters' and it will send meter readings to cloud. On cloud RMS can help in analyzing meter reading
                and automating bill generation.</p>

            </div>
          </div>

        </div>
      </div>
    </section>


    <section id="services" class="services">
      <div class="container aos-init aos-animate" data-aos="fade-up">

        <div class="section-title">

          <p class="pt-4">Flow Monitoring Benefits</p>

        </div>

        <div class="align-items-center text-center justify-content-center mt-30">
          <img src="assets/img/Flow-benefits.gif" class="img-fluid" alt="">
        </div>

      </div>
    </section>



    <section id="testimonials" class="testimonials section-bg services mt-30 ">
      <div class="container aos-init aos-animate" data-aos="fade-up">

        <div class="section-title">

          <p class="pt-4 pad_15">Custom Report and Dashboard For Flow Monitoring </p>

        </div>

        <div class="best_service">
          <owl-carousel [options]="SlideOptions3" [carouselClasses]="['owl-theme', 'sliding']">
            <div class="item" *ngFor="let img of Images1">
              <div style="align-content: center">
                <div class="icon-box icon-box2 icon-box3">
                  <div class="icon-container"><img src="{{img.img}}"></div>
                  <h4><a class="font-weight-500" href="">{{img.title}}</a></h4>
                  <p>{{img.text}}<span></span></p>

                </div>
              </div>
            </div>
          </owl-carousel>
        </div>
      </div>
    </section>








    <section id="testimonials" class="industries testimonials section-bg services">
      <div class="container aos-init aos-animate" data-aos="fade-up">

        <div class="section-title">

          <p class="pt-3" style="color: #fff;">Industries We Serve</p>

        </div>

        <div class="best_service">
          <owl-carousel [options]="SlideOptions2" [carouselClasses]="['owl-theme', 'sliding']">
            <div class="item" *ngFor="let img of Images2">
              <div class="">
                <div class="icon-container34">
                  <p><img class="indus-img" src="{{img.img}}"></p>
                  <div class="h3">{{img.title}}</div>
                </div>
              </div>
            </div>
          </owl-carousel>
        </div>

      </div>
    </section>




    <section id="testimonial-area" class="pt-5 padding-bottom-new">

      <div class="container">
          <div class="mx-auto">
              <header class="section-header text-center">

                  <h2  class="m_top">What our Customers are Saying</h2>
              </header>
          </div>
          <div class="testimonial-block" style="padding-bottom: 40px; padding-top: 45px;">
              <div style="width: 428px;" class="image_display"><img src="assets/img/user5.svg" alt=""
                      class="testimonial_img"></div>

              <div class="padding-both-side">

                  <h1> <span><img src="../../assets/img/comma.svg" class="commam"></span></h1>
                  <p class="text_align_center" style="font-size: 14px;">“Samyak's support is really good and we are
                      very happy with the services they have provided to us like hardware data integration through GSM
                      gateways. Two way communication is helping us a big time. We heartily appreciate all kind of
                      support.”</p>
                  <div class="testimonial">
                      <p class="testimonialFrom text_align_center" style="font-size: 14px;">Jummal Popis</p>
                      <p class="text_align_center" style="font-size: 14px;">Founder Circle</p>
                  </div>
              </div>
          </div>



      </div>

  </section>



    <app-latest-article></app-latest-article>




  </main>

  <app-footer></app-footer>

  <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i
      class="bi bi-arrow-up-short"></i></a>



  <!-- Testimonial js -->
  <script>
    System.import('https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js')
    $(document).ready(function () {

      $('.client-single').on('click', function (event) {
        event.preventDefault();

        var active = $(this).hasClass('active');

        var parent = $(this).parents('.testi-wrap');

        if (!active) {
          var activeBlock = parent.find('.client-single.active');

          var currentPos = $(this).attr('data-position');

          var newPos = activeBlock.attr('data-position');

          activeBlock.removeClass('active').removeClass(newPos).addClass('inactive').addClass(currentPos);
          activeBlock.attr('data-position', currentPos);

          $(this).addClass('active').removeClass('inactive').removeClass(currentPos).addClass(newPos);
          $(this).attr('data-position', newPos);

        }
      });

    }(jQuery));

  </script>
  <script>

    var testimonialItems = document.querySelectorAll(".item label");
    var timer;
    function cycleTestimonials(index) {
      timer = setTimeout(function () {
        var evt;
        if (document.createEvent) {
          //If browser = IE, then polyfill
          evt = document.createEvent('MouseEvent');
          evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        } else {
          //If Browser = modern, then create new MouseEvent
          evt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
            clientX: 20
          });
        }
        var ele = "." + testimonialItems[index].className;
        var ele2 = document.querySelector(ele)
        ele2.dispatchEvent(evt);
        index++; // Increment the index
        if (index >= testimonialItems.length) {
          index = 0; // Set it back to `0` when it reaches `3`
        }
        cycleTestimonials(index); // recursively call `cycleTestimonials()`
        document.querySelector(".testimonials").addEventListener("click", function () {
          clearTimeout(timer); //stop the carousel when someone clicks on the div
        });
      }, 3000); //adjust scroll speed in miliseconds
    }
    //run the function
    cycleTestimonials(0);
  </script>

</body>

</html>